// // // // import { UploadCloud, FileText, CheckCircle2 } from "lucide-react";

// // // // export default function UploadFilesStep({ formData, updateField }) {
// // // //   const handleFiles = (e) => {
// // // //     const chosen = Array.from(e.target.files).map((f) => ({
// // // //       name: f.name,
// // // //       size: `${(f.size / 1024 / 1024).toFixed(1)} MB`,
// // // //     }));
// // // //     updateField("files", [...formData.files, ...chosen]);
// // // //   };

// // // //   return (
// // // //     <div>
// // // //       <label className="block border-2 border-dashed border-indigo-200 bg-indigo-50/40 rounded-2xl px-6 py-14 text-center cursor-pointer hover:bg-indigo-50 transition">
// // // //         <input type="file" multiple className="hidden" onChange={handleFiles} />
// // // //         <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center mx-auto mb-5">
// // // //           <UploadCloud className="w-6 h-6 text-white" />
// // // //         </div>
// // // //         <p className="font-bold text-gray-900 mb-1">
// // // //           Drop CAD, STL, STEP, IGES, DWG, DXF or PDF
// // // //         </p>
// // // //         <p className="text-sm text-gray-500 mb-5">
// // // //           or click to browse from your computer · max 500 MB
// // // //         </p>
// // // //         <span className="inline-block bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-sm font-semibold px-6 py-2.5 rounded-xl">
// // // //           Choose Files
// // // //         </span>
// // // //       </label>

// // // //       {formData.files.length > 0 && (
// // // //         <div className="mt-6 space-y-3">
// // // //           {formData.files.map((file, i) => (
// // // //             <div
// // // //               key={i}
// // // //               className="flex items-center justify-between border border-gray-100 rounded-xl px-4 py-3"
// // // //             >
// // // //               <div className="flex items-center gap-3">
// // // //                 <div className="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center">
// // // //                   <FileText className="w-4 h-4 text-blue-500" />
// // // //                 </div>
// // // //                 <div>
// // // //                   <p className="text-sm font-semibold text-gray-900">{file.name}</p>
// // // //                   <p className="text-xs text-gray-500">{file.size} · Uploaded</p>
// // // //                 </div>
// // // //               </div>
// // // //               <CheckCircle2 className="w-5 h-5 text-green-500" />
// // // //             </div>
// // // //           ))}
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // }


// // // import { UploadCloud, FileText, CheckCircle2, X } from "lucide-react";

// // // export default function UploadFilesStep({ formData, updateField }) {
// // //   const handleFiles = (e) => {
// // //     const chosen = Array.from(e.target.files);
// // //     // ✅ Store actual File objects
// // //     const currentFiles = formData.enquiryFiles || [];
// // //     updateField("enquiryFiles", [...currentFiles, ...chosen]);
// // //     // Reset input
// // //     e.target.value = '';
// // //   };

// // //   const removeFile = (index) => {
// // //     const currentFiles = formData.enquiryFiles || [];
// // //     updateField("enquiryFiles", currentFiles.filter((_, i) => i !== index));
// // //   };

// // //   const formatFileSize = (bytes) => {
// // //     if (bytes < 1024) return bytes + ' B';
// // //     if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
// // //     return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
// // //   };

// // //   return (
// // //     <div>
// // //       <label className="block border-2 border-dashed border-indigo-200 bg-indigo-50/40 rounded-2xl px-6 py-14 text-center cursor-pointer hover:bg-indigo-50 transition">
// // //         <input 
// // //           type="file" 
// // //           multiple 
// // //           className="hidden" 
// // //           onChange={handleFiles} 
// // //         />
// // //         <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center mx-auto mb-5">
// // //           <UploadCloud className="w-6 h-6 text-white" />
// // //         </div>
// // //         <p className="font-bold text-gray-900 mb-1">
// // //           Drop CAD, STL, STEP, IGES, DWG, DXF or PDF
// // //         </p>
// // //         <p className="text-sm text-gray-500 mb-5">
// // //           or click to browse from your computer · max 500 MB
// // //         </p>
// // //         <span className="inline-block bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-sm font-semibold px-6 py-2.5 rounded-xl">
// // //           Choose Files
// // //         </span>
// // //       </label>

// // //       {(formData.enquiryFiles || []).length > 0 && (
// // //         <div className="mt-6 space-y-3">
// // //           {(formData.enquiryFiles || []).map((file, i) => (
// // //             <div
// // //               key={i}
// // //               className="flex items-center justify-between border border-gray-100 rounded-xl px-4 py-3"
// // //             >
// // //               <div className="flex items-center gap-3">
// // //                 <div className="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center">
// // //                   <FileText className="w-4 h-4 text-blue-500" />
// // //                 </div>
// // //                 <div>
// // //                   <p className="text-sm font-semibold text-gray-900">{file.name}</p>
// // //                   <p className="text-xs text-gray-500">{formatFileSize(file.size)} · Ready</p>
// // //                 </div>
// // //               </div>
// // //               <button
// // //                 type="button"
// // //                 onClick={() => removeFile(i)}
// // //                 className="text-gray-400 hover:text-red-500 transition"
// // //               >
// // //                 <X className="w-4 h-4" />
// // //               </button>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // }



// // import { useState, useRef } from "react";
// // import { 
// //   UploadCloud, 
// //   FileText, 
// //   X, 
// //   ChevronLeft, 
// //   ChevronRight, 
// //   Image, 
// //   File, 
// //   CheckCircle, 
// //   Zap,
// //   Sparkles,
// //   Trash2,
// //   Eye
// // } from "lucide-react";

// // export default function UploadFilesStep({ formData, updateField }) {
// //   const [previewIndex, setPreviewIndex] = useState(0);
// //   const scrollContainerRef = useRef(null);

// //   const handleFiles = (e) => {
// //     const chosen = Array.from(e.target.files);
// //     const currentFiles = formData.enquiryFiles || [];
// //     updateField("enquiryFiles", [...currentFiles, ...chosen]);
// //     e.target.value = '';
// //     setPreviewIndex(0);
// //   };

// //   const removeFile = (index) => {
// //     const currentFiles = formData.enquiryFiles || [];
// //     updateField("enquiryFiles", currentFiles.filter((_, i) => i !== index));
// //     if (previewIndex >= currentFiles.length - 1) {
// //       setPreviewIndex(Math.max(0, currentFiles.length - 2));
// //     }
// //   };

// //   const formatFileSize = (bytes) => {
// //     if (bytes < 1024) return bytes + ' B';
// //     if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
// //     return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
// //   };

// //   const isImageFile = (file) => {
// //     return file.type?.startsWith('image/');
// //   };

// //   const getFileIcon = (file) => {
// //     if (isImageFile(file)) {
// //       return <Image className="w-5 h-5 text-purple-500" />;
// //     }
// //     return <File className="w-5 h-5 text-blue-500" />;
// //   };

// //   const scrollLeft = () => {
// //     if (scrollContainerRef.current) {
// //       scrollContainerRef.current.scrollBy({ left: -200, behavior: 'smooth' });
// //     }
// //   };

// //   const scrollRight = () => {
// //     if (scrollContainerRef.current) {
// //       scrollContainerRef.current.scrollBy({ left: 200, behavior: 'smooth' });
// //     }
// //   };

// //   const files = formData.enquiryFiles || [];
// //   const hasFiles = files.length > 0;
// //   const currentFile = hasFiles ? files[previewIndex] : null;

// //   return (
// //     <div className="space-y-6">
// //       {/* Upload Area - Premium Design */}
// //       <div className="relative">
// //         <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-2xl blur-xl opacity-20"></div>
// //         <label className="relative block bg-gradient-to-br from-indigo-50/80 via-white to-purple-50/80 border-2 border-dashed border-indigo-200 rounded-2xl px-6 py-12 text-center cursor-pointer hover:border-indigo-400 transition-all duration-300 group">
// //           <input 
// //             type="file" 
// //             multiple 
// //             className="hidden" 
// //             onChange={handleFiles} 
// //             accept="image/*,.pdf,.stl,.step,.iges,.dwg,.dxf"
// //           />
          
// //           {/* Animated Icon */}
// //           <div className="relative w-20 h-20 mx-auto mb-4">
// //             <div className="absolute inset-0 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl animate-pulse opacity-75"></div>
// //             <div className="relative w-20 h-20 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-xl">
// //               <UploadCloud className="w-9 h-9 text-white" />
// //             </div>
// //             <div className="absolute -top-1 -right-1 bg-green-500 rounded-full p-1 shadow-lg">
// //               <Sparkles className="w-3 h-3 text-white" />
// //             </div>
// //           </div>

// //           <h3 className="font-bold text-gray-900 text-xl mb-1 group-hover:text-indigo-600 transition">
// //             Drop your files here
// //           </h3>
// //           <p className="text-sm text-gray-500 mb-1">
// //             Drag & drop or click to browse
// //           </p>
// //           <p className="text-xs text-gray-400 mb-4">
// //             Supports CAD, STL, STEP, IGES, DWG, DXF, PDF, Images
// //           </p>
          
// //           <div className="flex items-center justify-center gap-3 mb-4">
// //             <span className="inline-flex items-center gap-1.5 bg-indigo-100 text-indigo-700 text-xs font-semibold px-3 py-1.5 rounded-full">
// //               <Zap className="w-3 h-3" /> Max 500 MB
// //             </span>
// //             <span className="inline-flex items-center gap-1.5 bg-purple-100 text-purple-700 text-xs font-semibold px-3 py-1.5 rounded-full">
// //               <CheckCircle className="w-3 h-3" /> Secure Upload
// //             </span>
// //           </div>

// //           <span className="inline-block bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white text-sm font-semibold px-8 py-3 rounded-xl shadow-lg shadow-indigo-200/50 group-hover:shadow-indigo-300/70 transition-all duration-300 group-hover:scale-105">
// //             Choose Files
// //           </span>

// //           {hasFiles && (
// //             <div className="mt-4 flex items-center justify-center gap-2">
// //               <div className="flex -space-x-2">
// //                 {files.slice(0, 3).map((file, i) => (
// //                   <div key={i} className="w-8 h-8 rounded-full bg-gradient-to-br from-indigo-400 to-purple-400 border-2 border-white flex items-center justify-center text-white text-[10px] font-bold">
// //                     {file.name.charAt(0).toUpperCase()}
// //                   </div>
// //                 ))}
// //                 {files.length > 3 && (
// //                   <div className="w-8 h-8 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-gray-600 text-[10px] font-bold">
// //                     +{files.length - 3}
// //                   </div>
// //                 )}
// //               </div>
// //               <span className="text-sm font-medium text-indigo-600">
// //                 {files.length} file{files.length > 1 ? 's' : ''} uploaded
// //               </span>
// //             </div>
// //           )}
// //         </label>
// //       </div>

// //       {/* File Preview Section */}
// //       {hasFiles ? (
// //         <div className="bg-white border border-gray-100 rounded-2xl shadow-lg overflow-hidden">
// //           {/* Main Preview */}
// //           <div className="relative bg-gradient-to-br from-gray-50 to-indigo-50/30 p-6">
// //             <div className="relative bg-white rounded-xl shadow-md overflow-hidden" style={{ minHeight: '300px' }}>
// //               {currentFile && isImageFile(currentFile) ? (
// //                 <img
// //                   src={URL.createObjectURL(currentFile)}
// //                   alt={currentFile.name}
// //                   className="w-full h-full max-h-[320px] object-contain mx-auto p-4"
// //                 />
// //               ) : currentFile ? (
// //                 <div className="flex flex-col items-center justify-center h-[300px] p-8">
// //                   <div className="w-24 h-24 rounded-full bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center mb-4">
// //                     <FileText className="w-12 h-12 text-indigo-500" />
// //                   </div>
// //                   <p className="font-semibold text-gray-900 text-lg">{currentFile.name}</p>
// //                   <p className="text-sm text-gray-500">{formatFileSize(currentFile.size)}</p>
// //                   <p className="text-xs text-gray-400 mt-2 px-3 py-1 bg-gray-100 rounded-full">
// //                     {currentFile.type || 'Unknown type'}
// //                   </p>
// //                 </div>
// //               ) : null}

// //               {/* Navigation Arrows */}
// //               {files.length > 1 && (
// //                 <>
// //                   <button
// //                     onClick={scrollLeft}
// //                     className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/95 hover:bg-white rounded-full p-3 shadow-xl transition hover:scale-110 hover:shadow-2xl border border-gray-100"
// //                   >
// //                     <ChevronLeft className="w-5 h-5 text-gray-700" />
// //                   </button>
// //                   <button
// //                     onClick={scrollRight}
// //                     className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/95 hover:bg-white rounded-full p-3 shadow-xl transition hover:scale-110 hover:shadow-2xl border border-gray-100"
// //                   >
// //                     <ChevronRight className="w-5 h-5 text-gray-700" />
// //                   </button>
// //                 </>
// //               )}

// //               {/* File Counter Badge */}
// //               <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/80 backdrop-blur-sm text-white text-xs font-medium px-4 py-1.5 rounded-full flex items-center gap-2">
// //                 <Eye className="w-3 h-3" />
// //                 {previewIndex + 1} / {files.length}
// //               </div>
// //             </div>
// //           </div>

// //           {/* Thumbnail Scroller */}
// //           <div className="p-4 bg-gray-50/50 border-t border-gray-100">
// //             <div className="flex items-center gap-3">
// //               <button
// //                 onClick={scrollLeft}
// //                 className="flex-shrink-0 bg-white rounded-full p-2 shadow-md hover:shadow-lg transition hover:scale-110 border border-gray-200"
// //               >
// //                 <ChevronLeft className="w-4 h-4 text-gray-600" />
// //               </button>

// //               <div
// //                 ref={scrollContainerRef}
// //                 className="flex gap-3 overflow-x-auto scrollbar-hide py-2 px-1 flex-1"
// //                 style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
// //               >
// //                 {files.map((file, index) => (
// //                   <div
// //                     key={index}
// //                     className={`relative flex-shrink-0 cursor-pointer rounded-xl transition-all duration-200 ${
// //                       previewIndex === index
// //                         ? 'ring-2 ring-indigo-500 shadow-lg scale-105'
// //                         : 'hover:scale-105 hover:shadow-md'
// //                     }`}
// //                     onClick={() => setPreviewIndex(index)}
// //                   >
// //                     {isImageFile(file) ? (
// //                       <img
// //                         src={URL.createObjectURL(file)}
// //                         alt={file.name}
// //                         className="w-24 h-24 object-cover rounded-xl"
// //                       />
// //                     ) : (
// //                       <div className="w-24 h-24 bg-white rounded-xl flex flex-col items-center justify-center border border-gray-200">
// //                         {getFileIcon(file)}
// //                         <p className="text-[8px] text-gray-500 mt-1 max-w-[60px] truncate font-medium">
// //                           {file.name.split('.').pop()?.toUpperCase()}
// //                         </p>
// //                       </div>
// //                     )}
// //                     <button
// //                       type="button"
// //                       onClick={(e) => {
// //                         e.stopPropagation();
// //                         removeFile(index);
// //                       }}
// //                       className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-br from-red-500 to-pink-500 text-white rounded-full flex items-center justify-center hover:scale-110 transition shadow-md"
// //                     >
// //                       <Trash2 className="w-3 h-3" />
// //                     </button>
// //                     {previewIndex === index && (
// //                       <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-3 h-3 bg-indigo-500 rounded-full shadow-md" />
// //                     )}
// //                   </div>
// //                 ))}
// //               </div>

// //               <button
// //                 onClick={scrollRight}
// //                 className="flex-shrink-0 bg-white rounded-full p-2 shadow-md hover:shadow-lg transition hover:scale-110 border border-gray-200"
// //               >
// //                 <ChevronRight className="w-4 h-4 text-gray-600" />
// //               </button>
// //             </div>
// //           </div>

// //           {/* File Details Footer */}
// //           <div className="flex items-center justify-between px-6 py-3 bg-white border-t border-gray-100">
// //             <div className="flex items-center gap-3">
// //               <div className="flex -space-x-2">
// //                 {files.slice(0, 3).map((file, i) => (
// //                   <div key={i} className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-400 to-purple-400 border-2 border-white flex items-center justify-center text-white text-[8px] font-bold">
// //                     {file.name.charAt(0).toUpperCase()}
// //                   </div>
// //                 ))}
// //                 {files.length > 3 && (
// //                   <div className="w-7 h-7 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-gray-600 text-[8px] font-bold">
// //                     +{files.length - 3}
// //                   </div>
// //                 )}
// //               </div>
// //               <span className="text-sm font-medium text-gray-700">
// //                 {files.length} file{files.length > 1 ? 's' : ''}
// //               </span>
// //             </div>
// //             <div className="flex items-center gap-4 text-sm text-gray-500">
// //               <span className="flex items-center gap-1.5">
// //                 <CheckCircle className="w-4 h-4 text-green-500" />
// //                 Ready to upload
// //               </span>
// //               <span className="text-gray-300">|</span>
// //               <span>
// //                 {files.reduce((acc, f) => acc + f.size, 0) / (1024 * 1024) > 1
// //                   ? `${(files.reduce((acc, f) => acc + f.size, 0) / (1024 * 1024)).toFixed(1)} MB`
// //                   : `${(files.reduce((acc, f) => acc + f.size, 0) / 1024).toFixed(0)} KB`
// //                 }
// //               </span>
// //             </div>
// //           </div>
// //         </div>
// //       ) : (
// //         /* Empty State - Premium Design */
// //         <div className="relative">
// //           <div className="absolute -inset-1 bg-gradient-to-r from-indigo-200 via-purple-200 to-pink-200 rounded-2xl blur-xl opacity-30"></div>
// //           <div className="relative bg-gradient-to-br from-indigo-50/60 via-white to-purple-50/60 border-2 border-dashed border-gray-200 rounded-2xl p-12 text-center">
// //             <div className="relative inline-block mb-4">
// //               <div className="w-24 h-24 rounded-full bg-gradient-to-br from-indigo-100 to-purple-100 flex items-center justify-center mx-auto">
// //                 <Image className="w-12 h-12 text-indigo-400" />
// //               </div>
// //               <div className="absolute -top-1 -right-1 w-6 h-6 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-full flex items-center justify-center shadow-lg">
// //                 <Sparkles className="w-3 h-3 text-white" />
// //               </div>
// //             </div>
// //             <h3 className="font-bold text-gray-900 text-xl mb-2">Ready for your files</h3>
// //             <p className="text-sm text-gray-500 max-w-md mx-auto mb-4">
// //               Upload your CAD models, design files, images, or documents to help us understand your prototype requirements better.
// //             </p>
// //             <div className="flex flex-wrap justify-center gap-2">
// //               <span className="text-xs bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-700 px-3 py-1.5 rounded-full font-medium">CAD</span>
// //               <span className="text-xs bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-700 px-3 py-1.5 rounded-full font-medium">STL</span>
// //               <span className="text-xs bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-700 px-3 py-1.5 rounded-full font-medium">STEP</span>
// //               <span className="text-xs bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-700 px-3 py-1.5 rounded-full font-medium">Images</span>
// //               <span className="text-xs bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-700 px-3 py-1.5 rounded-full font-medium">PDF</span>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }




// import { useState, useRef } from "react";
// import { UploadCloud, FileText, X, ChevronLeft, ChevronRight, Image, File } from "lucide-react";

// export default function UploadFilesStep({ formData, updateField }) {
//   const [previewIndex, setPreviewIndex] = useState(0);
//   const scrollContainerRef = useRef(null);

//   const handleFiles = (e) => {
//     const chosen = Array.from(e.target.files);
//     const currentFiles = formData.enquiryFiles || [];
//     updateField("enquiryFiles", [...currentFiles, ...chosen]);
//     e.target.value = '';
//     setPreviewIndex(0);
//   };

//   const removeFile = (index) => {
//     const currentFiles = formData.enquiryFiles || [];
//     updateField("enquiryFiles", currentFiles.filter((_, i) => i !== index));
//     if (previewIndex >= currentFiles.length - 1) {
//       setPreviewIndex(Math.max(0, currentFiles.length - 2));
//     }
//   };

//   const formatFileSize = (bytes) => {
//     if (bytes < 1024) return bytes + ' B';
//     if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
//     return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
//   };

//   const isImageFile = (file) => {
//     return file.type?.startsWith('image/');
//   };

//   const scrollLeft = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: -150, behavior: 'smooth' });
//     }
//   };

//   const scrollRight = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: 150, behavior: 'smooth' });
//     }
//   };

//   const files = formData.enquiryFiles || [];
//   const hasFiles = files.length > 0;
//   const currentFile = hasFiles ? files[previewIndex] : null;

//   return (
//     <div>
//       {/* Upload Area - Compact */}
//       <label className="flex items-center justify-between border-2 border-dashed border-indigo-200 bg-indigo-50/30 rounded-xl px-5 py-4 cursor-pointer hover:bg-indigo-50 transition group">
//         <div className="flex items-center gap-4">
//           <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shrink-0">
//             <UploadCloud className="w-5 h-5 text-white" />
//           </div>
//           <div>
//             <p className="font-semibold text-gray-900 text-sm">Upload files</p>
//             <p className="text-xs text-gray-500">CAD, STL, STEP, Images, PDF</p>
//           </div>
//         </div>
//         <input 
//           type="file" 
//           multiple 
//           className="hidden" 
//           onChange={handleFiles} 
//           accept="image/*,.pdf,.stl,.step,.iges,.dwg,.dxf"
//         />
//         <span className="text-sm font-medium text-indigo-600 group-hover:text-indigo-700 whitespace-nowrap">
//           Browse →
//         </span>
//       </label>

//       {/* File Preview */}
//       {hasFiles ? (
//         <div className="mt-4 bg-white border border-gray-200 rounded-xl overflow-hidden">
//           {/* Main Preview */}
//           <div className="relative bg-gray-50 p-4">
//             <div className="bg-white rounded-lg overflow-hidden" style={{ minHeight: '200px' }}>
//               {currentFile && isImageFile(currentFile) ? (
//                 <img
//                   src={URL.createObjectURL(currentFile)}
//                   alt={currentFile.name}
//                   className="w-full max-h-[220px] object-contain mx-auto"
//                 />
//               ) : currentFile ? (
//                 <div className="flex flex-col items-center justify-center h-[200px]">
//                   <FileText className="w-12 h-12 text-indigo-400" />
//                   <p className="font-medium text-gray-900 text-sm mt-2">{currentFile.name}</p>
//                   <p className="text-xs text-gray-500">{formatFileSize(currentFile.size)}</p>
//                 </div>
//               ) : null}

//               {/* Navigation */}
//               {files.length > 1 && (
//                 <>
//                   <button
//                     onClick={scrollLeft}
//                     className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white rounded-full p-1.5 shadow-md transition"
//                   >
//                     <ChevronLeft className="w-4 h-4 text-gray-600" />
//                   </button>
//                   <button
//                     onClick={scrollRight}
//                     className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white rounded-full p-1.5 shadow-md transition"
//                   >
//                     <ChevronRight className="w-4 h-4 text-gray-600" />
//                   </button>
//                 </>
//               )}

//               {/* Counter */}
//               <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded-full">
//                 {previewIndex + 1}/{files.length}
//               </div>
//             </div>
//           </div>

//           {/* Thumbnails */}
//           <div className="flex items-center gap-2 px-4 py-3 border-t border-gray-100">
//             <button
//               onClick={scrollLeft}
//               className="shrink-0 bg-gray-100 rounded-full p-1 hover:bg-gray-200 transition"
//             >
//               <ChevronLeft className="w-3.5 h-3.5 text-gray-600" />
//             </button>

//             <div
//               ref={scrollContainerRef}
//               className="flex gap-2 overflow-x-auto scrollbar-hide flex-1"
//               style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
//             >
//               {files.map((file, index) => (
//                 <div
//                   key={index}
//                   className={`relative shrink-0 cursor-pointer rounded-lg border-2 transition ${
//                     previewIndex === index ? 'border-indigo-500' : 'border-gray-200 hover:border-indigo-300'
//                   }`}
//                   onClick={() => setPreviewIndex(index)}
//                 >
//                   {isImageFile(file) ? (
//                     <img
//                       src={URL.createObjectURL(file)}
//                       alt={file.name}
//                       className="w-14 h-14 object-cover rounded-lg"
//                     />
//                   ) : (
//                     <div className="w-14 h-14 bg-gray-50 rounded-lg flex items-center justify-center">
//                       <File className="w-5 h-5 text-blue-500" />
//                     </div>
//                   )}
//                   <button
//                     type="button"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       removeFile(index);
//                     }}
//                     className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition text-[10px]"
//                   >
//                     <X className="w-2.5 h-2.5" />
//                   </button>
//                 </div>
//               ))}
//             </div>

//             <button
//               onClick={scrollRight}
//               className="shrink-0 bg-gray-100 rounded-full p-1 hover:bg-gray-200 transition"
//             >
//               <ChevronRight className="w-3.5 h-3.5 text-gray-600" />
//             </button>
//           </div>

//           {/* Footer */}
//           <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-t border-gray-100 text-xs text-gray-500">
//             <span>{files.length} file{files.length > 1 ? 's' : ''}</span>
//             <span>
//               {files.reduce((acc, f) => acc + f.size, 0) / (1024 * 1024) > 1
//                 ? `${(files.reduce((acc, f) => acc + f.size, 0) / (1024 * 1024)).toFixed(1)} MB`
//                 : `${(files.reduce((acc, f) => acc + f.size, 0) / 1024).toFixed(0)} KB`
//               }
//             </span>
//           </div>
//         </div>
//       ) : (
//         /* Empty State - Clean & Simple */
//         <div className="mt-3 text-center py-6 border border-dashed border-gray-200 rounded-xl">
//           <Image className="w-8 h-8 text-gray-300 mx-auto mb-2" />
//           <p className="text-sm text-gray-400">No files uploaded yet</p>
//         </div>
//       )}
//     </div>
//   );
// }



import { useState, useRef } from "react";
import { UploadCloud, FileText, X, ChevronLeft, ChevronRight, Image, File } from "lucide-react";

export default function UploadFilesStep({ formData, updateField }) {
  const [previewIndex, setPreviewIndex] = useState(0);
  const scrollContainerRef = useRef(null);

  const handleFiles = (e) => {
    const chosen = Array.from(e.target.files);
    const currentFiles = formData.enquiryFiles || [];
    updateField("enquiryFiles", [...currentFiles, ...chosen]);
    e.target.value = '';
    setPreviewIndex(0);
  };

  const removeFile = (index) => {
    const currentFiles = formData.enquiryFiles || [];
    updateField("enquiryFiles", currentFiles.filter((_, i) => i !== index));
    if (previewIndex >= currentFiles.length - 1) {
      setPreviewIndex(Math.max(0, currentFiles.length - 2));
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  const isImageFile = (file) => {
    return file.type?.startsWith('image/');
  };

  // ✅ Navigation functions
  const goToPrevious = () => {
    setPreviewIndex((prev) => (prev > 0 ? prev - 1 : files.length - 1));
  };

  const goToNext = () => {
    setPreviewIndex((prev) => (prev < files.length - 1 ? prev + 1 : 0));
  };

  // ✅ Scroll functions for thumbnails
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -150, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 150, behavior: 'smooth' });
    }
  };

  const files = formData.enquiryFiles || [];
  const hasFiles = files.length > 0;
  const currentFile = hasFiles ? files[previewIndex] : null;

  return (
    <div>
      {/* Upload Area - Compact */}
      <label className="flex items-center justify-between border-2 border border-indigo-200 bg-indigo-50/30 rounded-xl px-5 py-4 cursor-pointer hover:bg-indigo-50 transition group">
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shrink-0">
            <UploadCloud className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="font-semibold text-gray-900 text-sm">Upload files</p>
            <p className="text-xs text-gray-500">CAD, STL, STEP, Images, PDF</p>
          </div>
        </div>
        <input 
          type="file" 
          multiple 
          className="hidden" 
          onChange={handleFiles} 
          accept="image/*,.pdf,.stl,.step,.iges,.dwg,.dxf"
        />
        <span className="text-sm font-medium text-indigo-600 group-hover:text-indigo-700 whitespace-nowrap">
          Browse →
        </span>
      </label>

      {/* File Preview */}
      {hasFiles ? (
        <div className="mt-4 bg-white border border-gray-200 rounded-xl overflow-hidden">
          {/* Main Preview */}
          <div className="relative bg-gray-50 p-4">
            <div className="bg-white rounded-lg overflow-hidden" style={{ minHeight: '200px' }}>
              {currentFile && isImageFile(currentFile) ? (
                <img
                  src={URL.createObjectURL(currentFile)}
                  alt={currentFile.name}
                  className="w-full max-h-[290px] object-contain mx-auto"
                />
              ) : currentFile ? (
                <div className="flex flex-col items-center justify-center h-[200px]">
                  <FileText className="w-12 h-12 text-indigo-400" />
                  <p className="font-medium text-gray-900 text-sm mt-2">{currentFile.name}</p>
                  <p className="text-xs text-gray-500">{formatFileSize(currentFile.size)}</p>
                </div>
              ) : null}

              {/* ✅ Navigation buttons - now working */}
              {files.length > 1 && (
                <>
                  <button
                    type="button"
                    onClick={goToPrevious}
                    className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white rounded-full p-1.5 shadow-md transition hover:scale-110"
                  >
                    <ChevronLeft className="w-4 h-4 text-gray-600" />
                  </button>
                  <button
                    type="button"
                    onClick={goToNext}
                    className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white rounded-full p-1.5 shadow-md transition hover:scale-110"
                  >
                    <ChevronRight className="w-4 h-4 text-gray-600" />
                  </button>
                </>
              )}

              {/* Counter */}
              <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded-full">
                {previewIndex + 1}/{files.length}
              </div>
            </div>
          </div>

          {/* Thumbnails */}
          <div className="flex items-center gap-2 px-4 py-3 border-t border-gray-100">
           

            <div
              ref={scrollContainerRef}
              className="flex gap-2 overflow-x-auto scrollbar-hide flex-1"
              style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
              {files.map((file, index) => (
                <div
                  key={index}
                  className={`relative shrink-0 cursor-pointer rounded-lg border-2 transition ${
                    previewIndex === index ? 'border-indigo-500' : 'border-gray-200 hover:border-indigo-300'
                  }`}
                  onClick={() => setPreviewIndex(index)}
                >
                  {isImageFile(file) ? (
                    <img
                      src={URL.createObjectURL(file)}
                      alt={file.name}
                      className="w-14 h-14 object-cover rounded-lg"
                    />
                  ) : (
                    <div className="w-14 h-14 bg-gray-50 rounded-lg flex items-center justify-center">
                      <File className="w-5 h-5 text-blue-500" />
                    </div>
                  )}
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeFile(index);
                    }}
                    className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition text-[10px]"
                  >
                    <X className="w-2.5 h-2.5" />
                  </button>
                </div>
              ))}
            </div>

          </div>

          {/* Footer */}
          <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-t border-gray-100 text-xs text-gray-500">
            <span>{files.length} file{files.length > 1 ? 's' : ''}</span>
            <span>
              {files.reduce((acc, f) => acc + f.size, 0) / (1024 * 1024) > 1
                ? `${(files.reduce((acc, f) => acc + f.size, 0) / (1024 * 1024)).toFixed(1)} MB`
                : `${(files.reduce((acc, f) => acc + f.size, 0) / 1024).toFixed(0)} KB`
              }
            </span>
          </div>
        </div>
      ) : (
        /* Empty State - Clean & Simple */
        <div className="mt-3 text-center py-6 border border-dashed border-gray-200 rounded-xl">
          <Image className="w-8 h-8 text-gray-300 mx-auto mb-2" />
          <p className="text-sm text-gray-400">No files uploaded yet</p>
        </div>
      )}
    </div>
  );
}